import { Type } from "class-transformer";
import { Duty } from "./duties";
import { Employee } from "./employees";
import { EventParticipations } from "./eventParticipations";
import { Events } from "./events";
import { AbstractJSONModel } from "./master-model";

export class EventsPostback extends AbstractJSONModel {
  @Type(() => Duty)
  duties: Duty[] = [];
  @Type(() => Events)
  event!: Events;
  @Type(() => EventParticipations)
  event_participations: EventParticipations[] = [];
  deleted_event_participations: number[] = [];
  deleted_duties: number[] = [];
}

export class RecurrenceError extends AbstractJSONModel {
  @Type(() => Events)
  event: Events = new Events();
  @Type(() => String)
  msg = "";
}

export class OverlappingEventParticipation extends RecurrenceError {
  @Type(() => Employee)
  employee: Employee = new Employee();
}

export class SameEventName extends RecurrenceError {}

export class NoEmployment extends RecurrenceError {
  @Type(() => Employee)
  employee: Employee = new Employee();
}

export class OtherRecurrenceErrors extends RecurrenceError {
  @Type(() => Employee)
  employee: Employee = new Employee();
}

export class RecurrenceErrorPostback extends AbstractJSONModel {
  @Type(() => OverlappingEventParticipation)
  OverlappendeAktivitetsDeltagelser!: OverlappingEventParticipation[];
  @Type(() => SameEventName)
  SammeAktivitetsNavn!: SameEventName[];
  @Type(() => NoEmployment)
  NoEmployments!: NoEmployment[];

  @Type(() => OtherRecurrenceErrors)
  OtherErrors!: OtherRecurrenceErrors[];
}
